import Vue from 'vue';
import Router from 'vue-router';

import Slider from '../components/Slider.vue';
import Slide from '../components/Slider/Slide.vue';
import News from '../components/News.vue';
import ArticlesDetails from '../components/Articles/Details.vue';
import Offers from '../components/Offers.vue';
import Machines from '../components/Machines/index.vue';
import MachinesDetails from '../components/Machines/Details.vue';
import Events from '../components/Events.vue';
import Gallery from '../components/Gallery/index.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Slider,
      children: [
        {
          path: 'slide/{id}',
          name: 'slide',
          component: Slide,
        },
      ],
    },
    {
      path: '/news',
      name: 'news',
      component: News,
    },
    {
      path: '/news/:id',
      name: 'news.details',
      component: ArticlesDetails,
    },
    {
      path: '/offers',
      name: 'offers',
      component: Offers,
    },
    {
      path: '/offers/:id',
      name: 'offers.details',
      component: ArticlesDetails,
    },
    {
      path: '/machines',
      name: 'machines',
      component: Machines,
    },
    {
      path: '/machines/:id',
      name: 'machines.details',
      component: MachinesDetails,
    },
    {
      path: '/events',
      name: 'events',
      component: Events,
    },
    {
      path: '/events/:id',
      name: 'events.details',
      component: ArticlesDetails,
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: Gallery,
    },
  ],
});
